import { render } from "./account-section.vue?vue&type=template&id=494d37c2&scoped=true&ts=true"
import script from "./account-section.vue?vue&type=script&lang=ts"
export * from "./account-section.vue?vue&type=script&lang=ts"

import "./account-section.vue?vue&type=style&index=0&id=494d37c2&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494d37c2"]])

export default __exports__